module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/guide_icon.a5d6c785.png";